import React from 'react';
import {  Users, FileText, CheckCircle, Sprout, TrendingUp, Clock, Shield, ArrowRight, DollarSign, Calendar, CreditCard, ShoppingCart,
  Landmark, 
  ArrowRightCircle, 
  Percent, 
  RefreshCcw, 
  Wheat 
} from "lucide-react";

export default function Kcc() {
  return (
    <div className="min-h-screen w-full bg-gray-50">
  {/* Top Page Header */}
  <div className="w-full bg-white py-8 ">
    <h1 className="text-center text-4xl font-bold text-gray-900">
      Kisan Credit Card (KCC)
    </h1>
  </div>
      <div className="w-full px-8 py-12 -mt-6">
        
        {/* Overview Section */}
        <div className="bg-blue-50 rounded-xl p-8 mb-12 -mt-10">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 flex items-center gap-3">
            Overview
          </h2>
          <div className="border-l-4 border-blue-600 pl-6">
            <p className="text-lg text-gray-700 leading-relaxed">
              The Kisan Credit Card (KCC) facility through Cooperative Societies provides farmers with easy, flexible, and timely access to credit for their cultivation needs. It ensures that farmers can purchase inputs, manage seasonal expenses, and handle unforeseen requirements without financial stress.
            </p>
          </div>
        </div>

    {/* Key Features Section - Card Style */}
<div className="mb-12 pl-8">
  <h2 className="text-3xl font-bold text-gray-900 mb-6">Key Features</h2>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
    {[
  { icon: Landmark, title: 'Hassle-free access to short-term agricultural loans', color: 'bg-blue-600' },
  { icon: ArrowRightCircle, title: 'Quick processing through Primary Agricultural Cooperative Credit Societies (PACCS)', color: 'bg-sky-500' },
  { icon: Percent, title: 'Affordable interest rates with government interest subvention', color: 'bg-gray-600' },
  { icon: RefreshCcw, title: 'Flexible withdrawal and repayment options', color: 'bg-blue-600' },
  { icon: Wheat, title: 'Coverage for crops, livestock, allied activities', color: 'bg-sky-500' }
]
.map((feature, index) => (
      <div key={index} className={`${feature.color} rounded-xl p-6 text-white shadow-lg`}>
        <div className="bg-white bg-opacity-20 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
          <feature.icon className="w-6 h-6 text-white" />
        </div>
        <p className="text-lg leading-snug">{feature.title}</p>
      </div>
    ))}
  </div>
</div>

        {/* Who Can Apply Section - Enhanced Card Grid */}
        <div className="mb-12">
       <h2 className="text-3xl font-bold mb-12 text-center text-gray-900">
    Who <span className="text-blue-600">Can Apply?</span>
  </h2>
          <div className="grid grid-cols-3 gap-8">
            {[
              { icon: Users, title: 'Small & Marginal Farmers', desc: 'Farmers with small landholdings seeking credit support', color: 'bg-blue-50 border-blue-200' },
              { icon: Users, title: 'Tenant Farmers & Sharecroppers', desc: 'Agricultural workers cultivating leased land', color: 'bg-purple-50 border-purple-200' },
              { icon: Sprout, title: 'Allied Activities Farmers', desc: 'Engaged in crop production, dairy, poultry, fisheries', color: 'bg-orange-50 border-orange-200' }
            ].map((category, index) => (
              <div key={index} className={`${category.color} border-2 rounded-xl p-8 hover:shadow-lg transition-shadow`}>
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-white p-3 rounded-lg shadow-sm">
                    <category.icon className="w-7 h-7 text-blue-600" />
                  </div>
                  <h3 className="font-bold text-gray-900 text-lg">{category.title}</h3>
                </div>
                <p className="text-gray-600 text-lg leading-relaxed">{category.desc}</p>
              </div>
            ))}
          </div>
        </div>
{/* Process Flow - Stepper Box Flow */}
<div className="mb-12">
  <h2 className="text-3xl font-bold text-gray-900 mb-6">Process Flow</h2>

  <div className="relative">
    {/* Horizontal Dotted Line */}
    <div className="hidden md:block absolute top-6 left-0 w-full border-t-2 border-dashed border-gray-400 z-0"></div>

    {/* Steps */}
    <div className="grid md:grid-cols-5 gap-6 relative z-10">
      {[
        "Application at PACCS",
        "Land & Eligibility Verification",
        "Credit Limit Assessment",
        "KCC Issued",
        "Amount Drawal",
      ].map((step, index) => (
        <div key={index} className="flex flex-col items-center text-center relative">
          
          {/* Step Number */}
          <div className="w-12 h-12 bg-blue-600 text-white rounded-full flex items-center justify-center font-bold mb-3">
            {index + 1}
          </div>

          {/* Step Card */}
          <div className="bg-blue-100 rounded-xl shadow-md p-4 w-full">
            <p className="text-gray-700 text-lg font-medium">{step}</p>
          </div>
        </div>
      ))}
    </div>
  </div>
</div>
{/* Benefits Section - Image Left, Icons on Right */}
<div className="mb-16 flex flex-col lg:flex-row items-stretch gap-10 px-6 lg:px-20 bg-gray-100 p-8 rounded-xl">
  {/* Left Image */}
  <div className="lg:w-1/2 flex justify-center">
    <img
      src="/Images/TVM Region (2).jpg"
      alt="Farmer Benefits"
      className="w-full rounded-xl shadow-lg object-cover h-full"
    />
  </div>

  {/* Right Content */}
  <div className="lg:w-1/2 flex flex-col justify-between">
  <h2 className="text-3xl font-bold text-gray-900 mb-8">Benefits to Farmers</h2>
  <ul className="space-y-6 flex-1 flex flex-col justify-between list-disc list-inside">
    <li className="text-lg text-gray-700">
      Reduces dependency on informal lenders
    </li>
    <li className="text-lg text-gray-700">
      Ensures timely purchase of seeds, fertilisers, pesticides
    </li>
    <li className="text-lg text-gray-700">
      Supports recurring and seasonal expenses
    </li>
    <li className="text-lg text-gray-700">
      Simplifies credit access through a single card
    </li>
  </ul>
</div>

</div>


      </div>
    </div>
  );
}